module.exports = __webpack_public_path__ + "static/media/blm_4bhk.6417e69d.jpg";